export const chart_global_danger_Color_100 = {
  "name": "--pf-chart-global--danger--Color--100",
  "value": "#c9190b",
  "var": "var(--pf-chart-global--danger--Color--100)"
};
export default chart_global_danger_Color_100;